module.exports = new __parcel__URL__("56409_h.341237f8.jpg").toString();